
<template>
    <v-card color="" elevation="0" class="px-4">
        <v-divider></v-divider>
        <div class="d-flex pt-3 pb-7 mt-2">
            <v-text-field style="flex: 0 1 300px" v-model="search" append-icon="mdi-magnify" outlined
                :label="this.$t('sales.clientsList.search')" single-line dense hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-card outlined class="px-2 py-1"><span class="--total">{{ $n(actives)}}</span><small>{{ $t('users.confirmed') }}</small></v-card>
            <v-card outlined class="px-2 py-1 mx-2"><span class="--total">{{ $n(documents.length - actives)}}</span><small>{{ $t('users.unconfirmed') }}</small></v-card>
            <v-card outlined class="px-2 py-1"><span class="--total">{{ $n(documents.length)}}</span><small>{{ $t('users.total') }}</small></v-card>
            <vue-json-to-csv :json-data="docToExport" :csv-title="`Clientes registrados (${computedDateFormatted})`"
                :separator="';'" :labels="csvLabels">
                <v-btn outlined color="primary" height="40" class="ml-2">
                    {{ $t("common.export") }}

                    <v-icon>mdi-download</v-icon>
                </v-btn>
            </vue-json-to-csv>
        </div>
        <v-card outlined>
            <v-data-table :headers="headers" :items="documents" :sort-by="['createdOnX']" :sort-desc="[true]" :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [10, 25, 50]
            }" :items-per-page="25" :search="search">
                <template v-slot:[`item.createdOnX`]="{ item }">
                    <span class="hide-text">{{ item.createdOnX }}</span>{{ item.createdOn | dateTime }}
                </template>
                <template v-slot:[`item.document`]="{ item }">
                   <span v-html="item.document"></span>
                
                </template>
               
                <template v-slot:[`item.score`]="{ item }">
                    <div class="d-flex align-center align-middle" style="width: 280px">
                        
                        <span v-html="item.score" v-if="!item.openScore"></span>
                        <v-btn small text class="ml-1" v-if="!item.openScore" @click="item.openScore = !item.openScore"><v-icon small>mdi-pencil</v-icon></v-btn>
                        <v-select v-if="item.openScore" outlined dense hide-details :items="['Pendente', '⁠Em análise', 'Inadimplente', 'Gold (30dfm)', 'Silver (15dfm)', 'Bronze (à vista)']" v-model="item.newScore"></v-select>
                        <v-btn @click="saveScore(item)" v-if="item.openScore" color="success" outlined class="ml-1 mb-1">Salvar</v-btn>
                    </div>
                 
                 </template>
                <template v-slot:[`item.verified`]="{ item }">
                    <!-- <template v-if="item.verified">
                        <span class="hide-text">{{ item.verified }}</span>
                        {{ item.verified | dateTime }}
                    </template> -->
                    <template v-if="item.verified">
                        <v-chip label color="green" class="white--text mx-4" small>{{ $t('sales.clientsList.confirmed')
                        }}</v-chip>
                    </template>
                    <v-chip v-else label color="error lighten-2 " class="mx-4" small>{{ $t('sales.clientsList.noConfirmed')
                    }}</v-chip>
                </template>
            </v-data-table>
        </v-card>

    </v-card>
</template>
<script>
import moment from 'moment'
import config from '@/store/config'
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import VueJsonToCsv from "vue-json-to-csv";

import { initializeApp } from "firebase/app";

import { getFirestore, collection, query, where, doc, updateDoc, getDocs } from "firebase/firestore";
export default {
    name: 'AccountsList',
    components: {
        VueJsonToCsv
    },
    data() {
        return {
            loading: true,
            search: this.$route.query.q ? this.$route.query.q : "",
            documents: [],
            docToExport: []
        }
    },

    computed: {
        csvLabels() {
            return {
                name: { title: this.$t('sales.clientsList.name') },
                company: { title:  this.$t('sales.clientsList.company')  },
                document: { title: this.$t('accountSettings.accountData.DocTitle') },
                score: { title: this.$t('sales.clientsList.createdDate') },
                email: { title: this.$t('sales.clientsList.email') },
                phone: { title: this.$t('sales.clientsList.tel') },
                createdOn: { title: this.$t('sales.clientsList.createdDate') },
                confirmedOn: { title: this.$t('sales.clientsList.verifiedDate') }
               
            }
        },
        computedDateFormatted() {
            return moment().format("YYYY-MM-DD HH mm");
        },
        headers() {
            return [
                // { text: 'ID', value: 'uid' },
                {
                    text: this.$t('sales.clientsList.name'),
                    align: 'start',
                    sortable: true,
                    value: 'name',
                },
                {
                    text: this.$t('sales.clientsList.email'),
                    align: 'start',
                    sortable: true,
                    value: 'email',
                },
                {
                    text: this.$t('sales.clientsList.company'),
                    align: 'start',
                    sortable: true,
                    value: 'company',
                },
                {
                    text: this.$t('sales.clientsList.doc'),
                    align: 'start',
                    sortable: true,
                    value: 'document',
                },
                {
                    text: this.$t('sales.clientsList.score'),
                    align: 'start',
                    sortable: true,
                    value: 'score',
                },
                {
                    text: this.$t('sales.clientsList.tel'),
                    align: 'start',
                    sortable: true,
                    value: 'phoneNumber',
                },
                {
                    text: this.$t('sales.clientsList.createAt'),
                    align: 'start',
                    sortable: true,
                    value: 'createdOnX',
                },
                {
                    text: this.$t('sales.clientsList.checked'),
                    align: 'start',
                    sortable: true,
                    value: 'verified',
                },

            ]
        },
        actives(){
            let docs = JSON.parse(JSON.stringify(this.documents))
            const i = 0;
            const result = docs.reduce(
            (accumulator, currentValue) => { return currentValue.hasOwnProperty('verified') && currentValue.verified ? accumulator+1 : accumulator}, i);
            return  result  
        }
    },
    mounted() {
        this.loadDocuments()
    },
    watch: {
        '$route.params.tab'(value) {
            if (value != 1)
                this.search = this.$route.query.q ? this.$route.query.q : ''
        },
        'search': {
            handler(value) {
                if (value) {
                    if (this.$route.query.q != value) {
                        this.$router.replace(`/sales/customers?q=${value}`)
                    }
                }
                else {
                    this.$router.replace(`/sales/customers`)
                }
            }
        }
    },
    methods: {
        saveScore(item){
            console.log('item', item)
            item.score = item.newScore
            item.openScore = false
            const firebase = initializeApp(config);
            const db = getFirestore(firebase);

            const masterRef = doc(db, "accounts", item.id);
            console.log('item to save', item);
            updateDoc(masterRef, {
                "score": item.score
            });

            this.loadDocuments()
        },
        loadDocuments() {
            this.loading = true
            const firebase = initializeApp(config)
            const db = getFirestore(firebase);
            const q = query(collection(db, "accounts"));
            const querySnapshot = getDocs(q);
            const documents = []
            querySnapshot.then((docs) => {
                docs.forEach((doc) => {
                    const computed = {
                        createdOn: moment(doc.data().createdOn).format('DD/MM/YYYY HH:mm:ss'),
                    }
                    const dt = doc.data()
                    dt.document = '<span style="display: none">' + doc.data().document.replace(' ', '').replace('-', '') + '  |</span>' + dt.document
                    documents.push({ ...dt, id: doc.id, computed: computed, score: doc.data().score ? doc.data().score : 'Pendente', openScore: false,
                    newScore: doc.data().score ? doc.data().score : 'Pendente', createdOnX: doc.data().createdOn ? moment(doc.data().createdOn).format('X') : '0' })
                    const doctoExport = {
                        name: doc.data().name,
                        company: doc.data().company,
                        email: doc.data().email,
                        document: doc.data().document,
                        phone: doc.data().phoneNumber,
                        score: doc.data().score ? doc.data().score : 'Pendente',
                        
                        createdOn:  moment(doc.data().createdOn).format('YYYY-MM-DD HH:mm:ss'),
                        confirmedOn: doc.data().verified ? moment(doc.data().verified).format('YYYY-MM-DD HH:mm:ss') : '',
                    }
                    this.docToExport.push(doctoExport)
                })
                this.documents = documents
                this.loading = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.hide-text {
    font-size: 0;
    text-indent: -999em;
}
.--total{
    line-height: .75em;
    text-align: center;
    display: block;
    font-weight: bold;
    padding-top: 2px;
    & + small{
        line-height: .75em;
        font-size: 70%;
        padding: 5px 0 0 0;
        display: block;
        text-align: center;
    }
}
</style>